import type { Resource, ResourceTypeValue } from '@my/directory-api';

/**
 * Editor draft shape — every field is a string (or a non-null discriminator)
 * so the form never has "is this undefined or null?" branches. We coerce to
 * the API shape only at the save boundary in the parent.
 *
 * Lives in its own file so the editor component stays a pure component
 * export — Vite's react-refresh plugin requires that for HMR to work.
 */
export interface ResourceDraft {
  /** Empty for a brand-new draft; the row's id when editing an existing one. */
  id: string;
  /** Empty until the operator picks a type from the chip row (new flow only). */
  type: ResourceTypeValue | '';
  name: string;
  displayName: string;
  mobileNumber: string;
  email: string;
  reference: string;
  /** OrganisationEquipmentType id (Trailer / Rigid only); empty otherwise. */
  organisationEquipmentTypeId: string;
  /** Home Site id; empty = unassigned. Applies to every resource type. */
  homeSiteId: string;
  /** Default vehicle Resource id (Driver only); empty otherwise. */
  defaultVehicleResourceId: string;
  /** Active / Inactive — drives the Status select. */
  status: 'Active' | 'Inactive';
}

export function emptyDraft(): ResourceDraft {
  return {
    id: '',
    type: '',
    name: '',
    displayName: '',
    mobileNumber: '',
    email: '',
    reference: '',
    organisationEquipmentTypeId: '',
    homeSiteId: '',
    defaultVehicleResourceId: '',
    status: 'Active',
  };
}

/** Hydrate a draft from an existing resource row (edit flow). */
export function toDraft(r: Resource): ResourceDraft {
  return {
    id: r.id,
    type: r.type,
    name: r.name,
    displayName: r.displayName ?? '',
    mobileNumber: r.mobileNumber ?? '',
    email: r.email ?? '',
    reference: r.reference ?? '',
    organisationEquipmentTypeId: r.organisationEquipmentTypeId ?? '',
    homeSiteId: r.homeSiteId ?? '',
    defaultVehicleResourceId: r.defaultVehicleResourceId ?? '',
    status: r.status,
  };
}
